import {
  APPLY_MILESTONES,
  APPLY_MILESTONES_PANEL_TITLE,
} from '../../config/applyMilestones';

const ApplyMilestones = ({ activeIndex = 0 }) => {
  const safeIndex = Math.min(
    Math.max(0, activeIndex),
    APPLY_MILESTONES.length - 1,
  );

  return (
    <div className="lk-conv-owen__milestones" aria-label="LoanKnow journey milestones">
      <p className="lk-conv-owen__milestones-title">{APPLY_MILESTONES_PANEL_TITLE}</p>
      <ol className="lk-conv-owen__milestones-list">
        {APPLY_MILESTONES.map((milestone, index) => {
          const isPast = index < safeIndex;
          const isCurrent = index === safeIndex;
          const stateClass = isCurrent
            ? 'lk-conv-owen__milestone--current'
            : isPast
              ? 'lk-conv-owen__milestone--past'
              : 'lk-conv-owen__milestone--upcoming';

          return (
            <li
              key={milestone.id}
              className={`lk-conv-owen__milestone ${stateClass}`}
              aria-current={isCurrent ? 'step' : undefined}
            >
              <div className="lk-conv-owen__milestone-head">
                <span className="lk-conv-owen__milestone-num" aria-hidden>
                  {index + 1}
                </span>
                <span className="lk-conv-owen__milestone-label">{milestone.label}</span>
              </div>
              {isCurrent && (
                <p className="lk-conv-owen__milestone-desc">{milestone.description}</p>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default ApplyMilestones;
